import { render, staticRenderFns } from "./OtherCompanyProfile.vue?vue&type=template&id=746b858a&scoped=true"
import script from "./OtherCompanyProfile.vue?vue&type=script&lang=js"
export * from "./OtherCompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./OtherCompanyProfile.vue?vue&type=style&index=0&id=746b858a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b858a",
  null
  
)

export default component.exports